import { Fragment } from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import App from "./App"
import CustomizationApp from "./customization/CustomizationApp"
import RequestSampleApp from "./customization/RequestSampleApp"
import SearchResult from "./SearchResult"
import { GlobalStyles } from "./customization/components/styled"

const Router = (props) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/togo" component={AddPropsToRoute(App, props)} />
        <Route
          path="/togo/search"
          component={AddPropsToRoute(SearchResult, props)}
        />
        <Route exact path="/togo-don" component={AddPropsToRoute(App, props)} />
        <Route
          path="/togo-don/search"
          component={AddPropsToRoute(SearchResult, props)}
        />
        <Route path="/customgobags" sensitive={false}>
          <Fragment>
            <GlobalStyles />
            <CustomizationApp {...props} />
          </Fragment>
        </Route>
        <Route path="/togo/request-quote">
          <Fragment>
            <GlobalStyles />
            <RequestSampleApp {...props} />
          </Fragment>
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

const AddPropsToRoute = (WrappedComponent, passedProps) => {
  return class Route extends React.Component {
    render() {
      const props = Object.assign({}, this.props, passedProps)
      return <WrappedComponent {...props} />
    }
  }
}

export default Router
